<template>
  <section v-if="themesGroupList.length" class="themes mb-5 md:mb-12">
    <carousel :title="$t('home.theme.title')" navigator :data="themesGroupList" swiper-container-class="mt-2 md:mt-4">
      <template #default="{ item }">
        <div class="flex flex-col gap-2 md:gap-5">
          <div v-for="theme in item" :key="theme.name" class="theme relative overflow-hidden rounded">
            <locale-link :to="`/regions/${regionId}/themes/${theme.id}`">
              <etg-img class="w-156px aspect-1.6 object-cover md:w-234px" :src="`fn:${theme.cover_image}`" :alt="theme.name" />
              <div class="mask bg-opacity-40 absolute top-0 left-0 flex items-center justify-center w-full h-full bg-black-80">
                <p class="text-center text-lg text-white font-500 line-clamp-2 px-4">{{ theme.name }}</p>
              </div>
            </locale-link>
          </div>
        </div>
      </template>
      <template #skeleton>
        <div class="skeleton-wrapper flex gap-2 overflow-hidden mt-2 md:gap-5 md:mt-4">
          <div v-for="i in 4" :key="i" class="flex flex-col gap-2 md:gap-5">
            <n-skeleton v-for="j in chunkSize" :key="j" class="skeleton-card w-156px h-full aspect-1.6 rounded md:w-234px" />
          </div>
        </div>
      </template>
    </carousel>
  </section>
</template>

<script lang="ts" setup>
import { NSkeleton } from 'naive-ui'

import Carousel from '@/components/common/carousel.vue'

import { useRegionStore } from '@/store/region'
import { useChunkedList } from '@/composables/useChunkedList'

const MAX_DISPLAY_COUNT = 20

const regionStore = useRegionStore()
const { regionInfo } = storeToRefs(regionStore)

const { regionId } = useRegion()

const themes = computed(() => regionInfo.value?.theme?.slice(0, MAX_DISPLAY_COUNT))

const { chunkSize, chunkedList: themesGroupList } = useChunkedList({ list: themes })
</script>
